import format from 'date-fns/format'
import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { parseISO } from 'date-fns'
import { type ReactElement } from 'react'
import { usdFormatter } from '../../../../../../shared/utils/formattingUtils'
import { recentActivitiesProxy } from '../recentActivitiesProxy'
import { buildAppTransactionPath } from '../../../../../../pages/app/transactions/[id]'
import { TransactionType } from '../../../../../../shared/types/GlobalTranactionTypeEnum'
import { determineTransactionColorClass, generateKey } from '../utils'
import { TableCell } from './TableCell'

export function RecentActivityRows (): ReactElement {
  const { recentTransactions } = useSnapshot(recentActivitiesProxy)
  return (
    <>
      {recentTransactions.map((transaction, i) => {
        const notLastRow = i !== (recentActivitiesProxy.recentTransactions.length - 1)
        const path = buildAppTransactionPath(transaction.id.toString())
        return (
          <tr
            key={generateKey(transaction)}
            className={cn('opacity-90 my-1 text-sm hover:bg-gray-50', notLastRow && 'border-b border-gray-100')}
          >
            <TableCell path={path}>
              {format(parseISO(transaction.transactedAt), 'MMM d, y')}
            </TableCell>
            <TableCell path={path}>
              <div className="text-ellipsis whitespace-nowrap overflow-hidden" style={{ maxWidth: '12rem' }}>
                {transaction.companyName}
              </div>
            </TableCell>
            <TableCell path={path}>
              <span className="text-ellipsis whitespace-nowrap overflow-hidden" style={{ maxWidth: '12rem' }}>
                {`${transaction.firstName} ${transaction.lastName}`}
              </span>
            </TableCell>
            <TableCell path={path} alignRight>
              <div className={determineTransactionColorClass(transaction)}>
                {transaction.ppSslTransactionType === TransactionType.Return ? `(${usdFormatter.format(transaction.amountCents)})` : usdFormatter.format(transaction.amountCents)}
              </div>
            </TableCell>
          </tr>
        )
      })}
    </>
  )
}
